// 节点类型
export const NodeType = {
    1:'Valid  Node',
    2:'Server Node',
    3:'Compute Node',
  }

  export const SoftTypeA = [
    {value:1,label:'Model FILE'},
    {value:2,label:'Bin'},
    {value:3,label:'DOCKER'},
  ]

  export const NodeTypeA = [
    {value:1,label:'Valid  Node'},
    {value:2,label:'Server Node'},
    {value:3,label:'Compute Node'},
  ]

  export const AppType = {
    1:'large Model',
    2:'TxtToImg',
    3:'TTS',
  }

  export const AppTypeA = [
    {value:1,label:'large Model'},
    {value:2,label:'TxtToImg'},
    {value:3,label:'TTS'},
  ]

  export const BusinessType = {
    1:'Academic Research Version',
    2:'Development Version',
    3:'Testing Version',
    4:'Trial Version',
    5:'Commercial Version',
  }

    export const BusinessTypeA = [
    {value:1,label:'Academic Research Version'},
    {value:2,label:'Development Version'},
    {value:3,label:'Testing Version'},
    {value:4,label:'Trial Version'},
    {value:5,label:'Commercial Version'},
    ]
  